<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/transactionmanage/select"
      :show="false"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      downloadPower="/transactionmanage/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
      totaltext="/transactionmanage/heji"
      :totalShow="true"
      @totalLookDialog="totalLookDialog()"
      totalName="合计"
      upActivityType="warning"
      upActivity="/transactionmanage/heji"
      :upActivityShow="true"
      @upActivitycz="settle"
      upActivityName="批量结算"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="formModel.orderNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input
          v-model="formModel.merchantName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户编号">
        <el-input
          v-model="formModel.merchantNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input
          v-model="formModel.merchantPhone"
          maxlength="11"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.agentPhone"
          maxlength="11"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否大POS交易">
        <el-select v-model="formModel.isPos">
          <el-option
            v-for="item in PlatoonIsPos"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.transType">
          <el-option
            v-for="item in PlatoontransType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收款类型">
        <el-select v-model="formModel.serviceType">
          <el-option
            v-for="item in PlatoonserviceType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡类型">
        <el-select v-model="formModel.cardType">
          <el-option
            v-for="item in PlatooncardType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="硬件产品类型">
        <el-select v-model="formModel.hardwareType">
          <el-option
            v-for="item in hardwareTypeStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="通道名称">
        <el-select v-model="formModel.chnCode">
          <el-option
            v-for="item in chnCode"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="首笔激活">
        <el-select v-model="formModel.activityTransFlag">
          <el-option
            v-for="item in activityTransFlag"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收取流量费">
        <el-select v-model="formModel.flowFeeFlag">
          <el-option
            v-for="item in flowFeeFlag"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="交易状态">
        <el-select v-model="formModel.transStatus">
          <el-option
            v-for="item in statusList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        fixed="left"
        prop="agentNo"
        label="代理商ID"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="280"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="transAmount"
        label="交易金额(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="transType"
        label="交易类型"
        :formatter="formatterTableTransType"
        min-width="220"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="transStatus"
        label="交易状态"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          {{
            scope.row.transStatus == "SUCCESS"
              ? "成功"
              : scope.row.transStatus == "FAILED"
              ? "失败"
              : scope.row.transStatus == "INIT"
              ? "初始化"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="结算状态"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableStatus"
      ></el-table-column>

      <el-table-column
        prop="merchantNo"
        label="商户编号"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="terminalId"
        label="终端号"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>

      <el-table-column
        prop="cardType"
        label="卡类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterCheckCardType"
      ></el-table-column>
      <el-table-column
        prop="transFee"
        label="手续费(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="transRate"
        label="交易费率(%)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantFee"
        label="商户手续费(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="settleFlag"
        label="秒到标记"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterCheckSettleFlag"
      ></el-table-column>
      <el-table-column
        prop="outAmount"
        label="到账金额(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="oriFeeAmount"
        label="出款手续费(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="feeAmount"
        label="实际出款手续费(元)"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="代理商姓名"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="代理商手机号"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantPhone"
        label="商户手机号"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="serviceType"
        label="收款类型"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableServiceType"
      ></el-table-column>
      <el-table-column
        prop="isPos"
        label="是否大POS交易"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="hardwareType"
        label="硬件产品类型"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="chnCode"
        label="通道名称"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="activityTransFlag"
        label="首笔激活"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableDataActivityTransFlag"
      ></el-table-column>
      <el-table-column
        prop="serviceFeeFlag"
        label="收取服务费"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          {{
            scope.row.serviceFeeFlag == 0
              ? "否"
              : scope.row.serviceFeeFlag == 1
              ? "是"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="flowFeeFlag"
        label="收取流量费"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableDataFlowFeeFlag"
      ></el-table-column>
      <el-table-column
        prop="vasFlowFee"
        label="流量费金额(元)"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="profitAttachReduceAmount"
        label="附加扣除金额(元)"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="交易日期"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="updateTime"
        label="结算时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>

      <el-table-column
        label="操作"
        min-width="100"
        fixed="right"
        v-if="hasPerm('/transactionmanage/settlement')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleRowSettle(scope.row)"
            v-if="hasPerm('/transactionmanage/settlement')"
            >结算
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>交易金额：{{ dialogObj || 0 }}元</p>
      </div>
    </show-info-dialog>
    <!-- 新增的 -->
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'结算'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item
        label-width="150px"
        label="是否推送商户"
        prop="isPutMerchant"
      >
        <el-select  v-model="dialogModel.isPutMerchant">
          <el-option
            v-for="item in isPutMerchantRules"
            :key="item.dictValue"
            :label="item.dictKey"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
  import FormDialog from "../../dialog/FormDialog";
import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import PosService from "service/PosService";

import TransactionType from "service/constant/TransactionType";
import SettlementType from "service/constant/SettlementType";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "transactionmanage",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
    FormDialog
  },
  data() {
    return {
      dialogModel: {
        isPutMerchant: '0',
        id: "",
      },
      dialogObj: {},
      formModel: {
        userId: "",
        orderNo: "",
        merchantName: "",
        merchantNo: "",
        merchantPhone: "",
        agentPhone: "",
        time: TimeRange.SecondRange,
        transType: "",
        serviceType: "",
        hardwareType: "",
        cardType: "",
        chnCode: "",
        isPos: "",
        activityTransFlag: "",
        flowFeeFlag: "",
        transStatus: "",
      },
      chnCode: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      activityTransFlag: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "否",
        },
        {
          code: "1",
          name: "是",
        },
      ],
      flowFeeFlag: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "否",
        },
        {
          code: "1",
          name: "是",
        },
      ],
      isPutMerchantRules: [
        {
          dictValue: "0",
          dictKey: "否",
        },
        {
          dictValue: "1",
          dictKey: "是",
        },
      ],
      statusList: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "SUCCESS",
          dictValue: "成功",
        },
      ],
      PlatoonIsPos: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "Y",
          dictValue: "是",
        },
        {
          dictKey: "N",
          dictValue: "否",
        },
      ],
      PlatoontransType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      PlatoonserviceType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      PlatooncardType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "扫码",
        },
        {
          dictKey: "1",
          dictValue: "贷记卡",
        },
        {
          dictKey: "2",
          dictValue: "借记卡",
        },
      ],
      dialogRules: {
        isPutMerchant: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      hardwareTypeStatus: [{ id: "", name: "全部" }],
      serviceType: [],
      transactionType: TransactionType,
      statusType: SettlementType,
      tableData: [],
      submitService: TransactionService.transactionmanageList,
      dialogService: TransactionService.settleAccountsOnly,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("收款类型", (res) => {
      this.serviceType = res;
      this.PlatoonserviceType = [...this.PlatoonserviceType, ...res];
    });
    this.getTypeNames("transType", (res) => {
      this.PlatoontransType = [...this.PlatoontransType, ...res];
    });
    this.getTypeNames("chnName", (res) => {
      this.chnCode = [...this.chnCode, ...res];
    });
  },
  computed: {
    dialogData() {
      const params = {
        isPutMerchant: this.dialogModel.isPutMerchant,
        id: this.dialogModel.id,
      };
      return params;
    },
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        chnCode: this.formModel.chnCode,
        merchantName: this.formModel.merchantName,
        merchantNo: this.formModel.merchantNo,
        merchantPhone: this.formModel.merchantPhone,
        agentPhone: this.formModel.agentPhone,
        userId: this.formModel.userId,
        orderNo: this.formModel.orderNo,
        transType: this.formModel.transType,
        serviceType: this.formModel.serviceType,
        cardType: this.formModel.cardType,
        hardwareType: this.formModel.hardwareType,
        activityTransFlag: this.formModel.activityTransFlag,
        transStatus: this.formModel.transStatus,
        flowFeeFlag: this.formModel.flowFeeFlag,
        isPos: this.formModel.isPos,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: TimeRange.SecondRange,
        isPos: "",
        transType: "",
        serviceType: "",
        cardType: "",
        hardwareType: "",
        chnCode: "",
        activityTransFlag: "",
        transStatus: "",
        flowFeeFlag: "",
      };
      this.page = this.$refs.commonTable.page;
      this.gethardwareTypeStatus();
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        TransactionService.transactionmanageList,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8885",
            "/qpayInfo/qpay-info/"
          )
        : "";
    },
    totalLookDialog() {
      this.doLoad(
        TransactionService.transactionmanageheji,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    settle() {
      this.showConfirm("确认结算？")
        .then(() => {
          this.doLoad(
            TransactionService.settleAccounts,
            this.submitData,
            (res) => {
              this.doCheck(res, (res) => {
                this.showSuccess(res.respMsg);
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
    handleRowSettle(row) {
        this.$refs.formDialog.open();
      this.dialogModel.id = row.id;
    
      // this.showConfirm("确认结算？")
      //     .then(() => {
      //         this.doLoad(
      //             TransactionService.settleAccountsOnly,
      //             {
      //                 id: row.id
      //             },
      //             (res) => {
      //                 this.doCheck(res, (res) => {
      //                     this.showSuccess(res.respMsg);
      //                 });
      //             },
      //             "信息获取失败"
      //         );
      //     })
      //     .catch(() => {});
    },
    dialogClose() {
      this.dialogModel = {
        id: "",
        isPutMerchant: "0",
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    formatterTableTransType(row, column, cellValue, index) {
      let value = "--";
      this.PlatoontransType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTableServiceType(row, column, cellValue, index) {
      let value = "--";
      this.serviceType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTableStatus(row, column, cellValue, index) {
      let value = "--";
      this.statusType.forEach((item) => {
        if (item.value == cellValue) {
          value = item.label;
        }
      });
      return value;
    },
    formatterTableDataActivityTransFlag(row, column, cellValue, index) {
      let value = "--";
      this.activityTransFlag.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
    formatterTableDataFlowFeeFlag(row, column, cellValue, index) {
      let value = "--";
      this.flowFeeFlag.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
    formatterCheckSettleFlag: function (row, column) {
      switch (row.settleFlag) {
        case "0":
          return "T0结算";
          break;
        default:
          return "--";
      }
    },
    formatterCheckCardType: function (row, column) {
      switch (row.cardType) {
        case "0":
          return "扫码";
          break;
        case "1":
          return "贷记卡";
          break;
        case "2":
          return "借记卡";
          break;
        default:
          return "--";
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/TransactionManage.vue